import { render, staticRenderFns } from "./PropTopCommentsPosts.vue?vue&type=template&id=15b35e7a&scoped=true&"
import script from "./PropTopCommentsPosts.vue?vue&type=script&lang=js&"
export * from "./PropTopCommentsPosts.vue?vue&type=script&lang=js&"
import style0 from "./PropTopCommentsPosts.vue?vue&type=style&index=0&id=15b35e7a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15b35e7a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/home/runner/_work/studio/studio/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCarousel } from 'vuetify/lib'
import { VCarouselItem } from 'vuetify/lib'
installComponents(component, {VCarousel,VCarouselItem})
